import PersonIcon from "@material-ui/icons/Person";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import WifiIcon from "@material-ui/icons/Wifi";
import WifiOffIcon from "@material-ui/icons/WifiOff";
import CheckIcon from "@material-ui/icons/Check";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import StorageIcon from "@material-ui/icons/Storage";

export type IconTypes =
  | "total"
  | "BoxAvailable"
  | "BoxWaitingPickup"
  | "BoxExpired"
  | "users"
  | "online"
  | "offline"
  | "boxopened"
  | "none";

type IconByName = {
  [key in IconTypes | string]: JSX.Element;
};
const cardIcons: IconByName = {
  users: <PersonIcon style={{ fontSize: "4rem", color: "var(--iconBlue2)" }} />,
  boxopened: (
    <LockOpenIcon
      fontSize="large"
      style={{ fontSize: "4rem", color: "var(--iconRed)" }}
    />
  ),
  online: <WifiIcon style={{ fontSize: "3rem", color: "var(--iconGreen)" }} />,
  offline: (
    <WifiOffIcon style={{ fontSize: "3rem", color: "var(--iconRed)" }} />
  ),
  BoxAvailable: (
    <CheckIcon
      fontSize="large"
      style={{ fontSize: "4rem", color: "var(--iconGreen)" }}
    />
  ),
  BoxExpired: (
    <ReportProblemIcon
      fontSize="large"
      style={{ fontSize: "4rem", color: "var(--iconYellow)" }}
    />
  ),
  BoxWaitingPickup: (
    <CardGiftcardIcon
      fontSize="large"
      style={{ fontSize: "4rem", color: "var(--iconBlue1)" }}
    />
  ),
  total: (
    <StorageIcon
      fontSize="large"
      style={{ fontSize: "4rem", color: "var(--grayLv2)" }}
    />
  ),
  BoxTampered: (
    <LockOpenIcon
      fontSize="large"
      style={{ fontSize: "4rem", color: "var(--grayLv2)" }}
    />
  ),
  none: <div />,
};

interface CardIconsProps {
  name: IconTypes | string;
}
export default function CardIcons({ name }: CardIconsProps) {
  return cardIcons[name];
}
